module.exports = __webpack_public_path__ + "static/media/arrow-dot-white.3ebc1192.svg";